"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMedia = exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const media_1 = __importDefault(require("../media"));
const PREFIX = "VerticalRoller";
exports.classes = {
    leftColumn: `${PREFIX}-leftColumn`,
    selectors: `${PREFIX}-selectors`,
    selector: `${PREFIX}-selector`,
    controls: `${PREFIX}-controls`,
    rightColumn: `${PREFIX}-rightColumn`,
    slide: `${PREFIX}-slide`,
    image: `${PREFIX}-image`,
    brandIcon: `${PREFIX}-brandIcon`,
    description: `${PREFIX}-description`,
    cta: `${PREFIX}-cta`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    position: "relative",
    [`.${exports.classes.leftColumn}`]: {
        padding: "0",
        display: "flex",
        flexDirection: "column",
        [theme.breakpoints.up("md")]: {
            paddingTop: "30px"
        }
    },
    [`.${exports.classes.selectors}`]: {
        marginBottom: 0,
        [theme.breakpoints.up("md")]: {
            marginBottom: "48px"
        }
    },
    [`.${exports.classes.selector}`]: {
        marginTop: "8px",
        "&:first-of-type": {
            marginTop: 0
        }
    },
    [`.${exports.classes.controls}`]: {
        display: "none",
        [theme.breakpoints.up("md")]: {
            display: "flex",
            marginTop: "auto",
            width: "70px",
            zIndex: 2,
            overflow: "unset",
            position: "relative",
            bottom: "auto"
        },
        // TODO: This is a temporary hack. When the vertical swiping will be
        // available, we'll revisit this.
        "&::before": {
            content: "''",
            position: "absolute",
            zIndex: 0,
            top: "1px",
            right: "-8px",
            bottom: "-8px",
            left: "-8px",
            background: `linear-gradient(
      to right,
      ${theme.colours.pearl} 80%,
      ${theme.colours.pearl}00 100%
    )`
        }
    },
    [`.${exports.classes.rightColumn}`]: {
        [`.${exports.classes.slide}`]: {
            display: "block",
            "&::after": {
                content: "''",
                display: "block",
                clear: "both"
            }
        }
    },
    [`.${exports.classes.image}`]: {
        position: "relative",
        display: "block",
        width: "100%",
        backgroundPosition: "center center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        marginBottom: "24px",
        [theme.breakpoints.up("md")]: {
            height: "400px"
        }
    },
    [`.${exports.classes.brandIcon}`]: {
        position: "absolute",
        top: "10px",
        left: "10px",
        backgroundColor: theme.colours.white,
        fill: theme.colours.white,
        padding: "5px",
        height: "50px",
        zIndex: 1
    },
    [`.${exports.classes.description}`]: {
        marginBottom: "24px",
        fontSize: "1rem"
    },
    [`.${exports.classes.cta}`]: {
        float: "right",
        position: "inherit",
        marginBottom: "30px"
    }
}));
exports.StyledMedia = (0, styles_1.styled)(media_1.default)(({ theme }) => ({
    height: "200px",
    [theme.breakpoints.up("md")]: {
        height: "400px"
    }
}));
//# sourceMappingURL=data:application/json;base64,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